/** Colunas do order by da pesquisa das classificações nas análises de mercados de clientes */
export enum ClienteAnaliseMercadoClassificacaoSearchOrderBy {
    StatusPretendido = 1,
    StatusProjetado = 2,
    CodigoIntegracaoErpCliente = 3,
    NomeCliente = 4,
    NomeRepresentante = 5,
    ClassificacoesNome = 6,
    CadastroESituacaoCliente = 7,
    NomeClienteTipo = 8,
    NomeItemTipo = 9,
    QuantidadePotencial = 10,
    PesoPotencial = 11,
    ValorPotencial = 12,
    QuantidadePretendida = 13,
    QuantidadePretendidaPerc = 14,
    QuantidadePretendidaValorUnitario = 15,
    PesoPretendido = 16,
    PesoPretendidoPerc = 17,
    PesoPretendidoValorUnitario = 18,
    ValorPretendido = 19,
    ValorPretendidoPerc = 20,
    QuantidadeProjetada = 21,
    QuantidadeProjetadaPerc = 22,
    QuantidadeProjetadaValorUnitario = 23,
    PesoProjetado = 24,
    PesoProjetadoPerc = 25,
    PesoProjetadoValorUnitario = 26,
    ValorProjetado = 27,
    ValorProjetadoPerc = 28,
    QuantidadeRealizada = 29,
    QuantidadeRealizadaPercPretendida = 30,
    QuantidadeRealizadaPercProjetada = 31,
    PesoRealizado = 32,
    PesoRealizadoPercPretendido = 33,
    PesoRealizadoPercProjetado = 34,
    ValorRealizado = 35,
    ValorRealizadoPercPretendido = 36,
    ValorRealizadoPercProjetado = 37
};
